export interface RestartTranslateTaskRequest {
    task_id: string;
}

export type RestartTranslateTaskResponse = void;

/**
 * 重启翻译任务
 */
export interface RestartTranslateTaskApi {
    /**
     * 重启翻译任务
     * @param data 重启翻译任务请求
     */
    restartTranslateTask(data: RestartTranslateTaskRequest): Promise<RestartTranslateTaskResponse>;
}

export const RestartTranslateTaskApi = Symbol('RestartTranslateTaskApi');
